import type { PageProps } from '@libs/core';
import type { Entry } from 'contentful';
import { buildPage } from '../../utils';

export default function HelpPage({ entry }: PageProps) {
    const { items } = entry?.fields || {};

    return buildPage(items as Entry[]);
}
